export default __webpack_public_path__ + "static/media/headshot.0e99d6c0.jpg";